import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface Information extends SVGProps<SVGSVGElement> {
  label?: string
}

const Information: React.FC<Information> = ({
  label = 'information',
  ...restProps
}) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="information-svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.0001 18.3334C5.39758 18.3334 1.66675 14.6026 1.66675 10.0001C1.66675 5.39758 5.39758 1.66675 10.0001 1.66675C14.6026 1.66675 18.3334 5.39758 18.3334 10.0001C18.3334 14.6026 14.6026 18.3334 10.0001 18.3334ZM9.16675 9.16675V14.1667H10.8334V9.16675H9.16675ZM9.16675 5.83342V7.50008H10.8334V5.83342H9.16675Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default Information
